import {
  contactMethodsFromFormkit,
  contactMethodsToFormkit,
  organizationContactConfig,
  type ContactMethodsFormkit,
} from "@/components/contactMethods";
import type { ContactMethodCollection } from "@/views/person/person";
import type { Organization, OrganizationFormKit, OrganizationNew } from "./organization";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  responseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
};

function addAuthRequestFields(entity: Organization) {
  entity._authRequestFields = ["id"];
  return entity;
}
function getInitialData(): OrganizationFormKit {
  const result: OrganizationFormKit = {
    name: "",
    contactMethods: contactMethodsToFormkit([], organizationContactConfig),
  };
  result._authRequestFields = ["id"];
  return result;
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Organization }) {
  addAuthRequestFields(response.data);
  response.data.displayName = response.data.name;
  return response.data as Organization;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Organization }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

function requestAdapter(data: Organization | OrganizationNew | OrganizationFormKit) {
  const { affiliations: _affiliations, ...rest } = data as Organization & { affiliations?: unknown };
  return {
    ...rest,
    contactMethods: contactMethodsFromFormkit(data.contactMethods, organizationContactConfig),
  };
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit<T extends Organization | OrganizationNew | OrganizationFormKit>(data: T) {
  const form = data as T & { contactMethods: ContactMethodsFormkit };
  form.contactMethods = contactMethodsToFormkit(data.contactMethods, organizationContactConfig);
}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: Organization | OrganizationNew | OrganizationFormKit) {
  const source = data.contactMethods as ContactMethodsFormkit | ContactMethodCollection | null | undefined;
  (data as { contactMethods: ReturnType<typeof contactMethodsFromFormkit> }).contactMethods =
    contactMethodsFromFormkit(source, organizationContactConfig);
}
